import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './InvoiceList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaEdit, FaEllipsisH, FaFileInvoice, FaFilePdf, FaFilter, FaInfo, FaPlus, FaSearch, FaTrash, FaUser } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { deliveryActions } from '../../sagas/deliveryNoteSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { DELIVERY_NOTE_PAGE } from '../../routes/routeConstants';
import PaymentBloc from './PaymentBloc';
import { format, parse } from 'date-fns';
import { invoiceSupplierActions } from '../../sagas/invoiceSupplierSlice';
import InvoiceForm from './InvoiceForm';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import { generateSupplierInvoicePdf } from '../../helpers/generateSupplierInvoicePdf';
import Select from "react-select";
import ViewFacture from './ViewFacture';
import { supplierActions } from '../../sagas/supplierSlice';

const SupplierInvoiceList = () => {
    const dispatch = useDispatch();
    const { invoices, loading } = useSelector((state) => state.invoiceSupplier);
    const { company } = useSelector(state => state.auth);
    const { t } = useTranslation();
    const searchInputRef = useRef(null);
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const { suppliers, loading: suppliersLoading } = useSelector(state => state.suppliers);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedInvoiceForEdit, setSelectedInvoiceForEdit] = useState(null);
    const [filters, setFilters] = useState({
        fournisseurId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: ''
    });

    useEffect(() => {
        if (suppliers.length === 0) {
            // Fetch suppliers for supplier report
            const fetchSuppliers = async () => {
                dispatch(supplierActions.search({
                    query: ""
                }));
            };

            fetchSuppliers();
        }
    }, []);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [invoices]);

    useEffect(() => {
        let payload = {
            ...filters
        };
        dispatch(invoiceSupplierActions.search(payload));
    }, [filters.fournisseurId, filters.dateFrom, filters.dateTo]);


    const debouncedSearch = () => {
        dispatch(invoiceSupplierActions.search({
            ...filters,
        }));
    }

    const fournisseurOptions = suppliers?.map(sup => ({
        solde: sup.solde,
        totalDebit: sup.totalDebit,
        totalCredit: sup.totalCredit,
        value: sup.id,
        label: sup.typeFournisseur === 'PARTICULIER' ? `${sup.nom} ${sup.prenom} (${sup.code})` : `${sup.entreprise}(${sup.code})`,
    })) ?? [];

    const handleSupplierChange = (value) => {
        setFilters(f => ({ ...f, fournisseurId: value }));
    };

    const clearFilters = () => {
        setFilters({
            query: '',
            fournisseurId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate)
        });
    };

    const handleEditInvoice = (invoice) => {
        setSelectedInvoiceForEdit(invoice);
        setShowEditModal(true);

        let payload = {
            ...filters
        };
        dispatch(invoiceSupplierActions.search(payload));
    };


    const getStatusBadge = (status) => {
        switch (status) {
            case 'IMPAYE':
                return <Badge color="danger">Impayée</Badge>;
            case 'PAYEE':
                return <Badge color="success">Payée</Badge>;
            case 'PARTIELLEMENT_PAYEE':
                return <Badge color="warning">Partiellement payée</Badge>;
            case 'ANNULEE':
                return <Badge color="secondary">Annulée</Badge>;
            default:
                return null;
        }
    };

    if (loading) {
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                }}
            >
                <Spinner color="primary" />
            </div>
        );
    }

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedInvoiceForEdit(null);

        let payload = {
            ...filters
        };
        dispatch(invoiceSupplierActions.search(payload));

    };

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaFileInvoice className="text-primary me-2" />
                                {t('facture.list')}
                            </h4>
                            {/* <Button color="primary" onClick={() => window.location.href = '/invoices/new'}>
                                <FaPlus className="me-2" /> {t('facture.newInvoice')}
                            </Button> */}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* Filtres et actions en lot */}
            <Card className="shadow-sm mb-4">
                <CardBody>
                    <Row className="mb-3 g-2 align-items-end">
                        <Col lg={4} md={4} sm={6} xs={12}>
                            <FormGroup className="mb-0">
                                <Label className="mb-1">{t('reglement.search')}</Label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light">
                                        <FaSearch />
                                    </span>
                                    <Input
                                        type="text"
                                        innerRef={searchInputRef}
                                        placeholder={t('facture.searchPlaceholder')}
                                        value={filters.query}
                                        onChange={e => {
                                            const value = e.target.value.toUpperCase();
                                            setFilters(prevFilters => ({
                                                ...prevFilters,
                                                query: value
                                            }));
                                        }}
                                        className="text-uppercase"
                                        style={{ textTransform: 'uppercase' }}
                                        onKeyDown={e => {
                                            if (e.key === 'Enter') {
                                                debouncedSearch(e.target.value.toUpperCase());
                                            }
                                        }}
                                    />
                                </div>
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for="supplierSelect" className="form-label">
                                    <FaUser className="me-1" /> Fournisseur
                                </Label>
                                <Select
                                    id="supplierSelect"
                                    options={fournisseurOptions}
                                    isLoading={suppliersLoading}
                                    value={fournisseurOptions.find(option => option.value === filters.fournisseurId)}
                                    onChange={(option) => handleSupplierChange(option?.value)}
                                    placeholder="Sélectionner..."
                                    isClearable
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={2} md={3} sm={6} xs={12}>
                            <FormGroup className="mb-0">
                                <Label for="dateFrom" className="mb-1">Date début</Label>
                                <Input
                                    type="date"
                                    id="dateFrom"
                                    value={filters.dateFrom}
                                    onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value }))}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={2} md={3} sm={6} xs={12}>
                            <FormGroup className="mb-0">
                                <Label for="dateTo" className="mb-1">Date fin</Label>
                                <Input
                                    type="date"
                                    id="dateTo"
                                    value={filters.dateTo}
                                    onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value }))}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                            <Button
                                color="secondary"
                                onClick={clearFilters}
                                title={t('common.clearFilters')}
                                className="mb-3"
                                style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                                <FaFilter />
                            </Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {loading ? (
                <div className="text-center py-5">
                    <Spinner color="primary" />
                    <div className="mt-2 text-muted">{t('common.loading')}</div>
                </div>
            ) : (
                <>
                    <table className="table table-hover table-striped table-bordered" style={{ fontSize: 12 }}>
                        <thead className="thead-light">
                            <tr>
                                <th className="align-middle text-center">{t('facture.table.invoiceNb')}</th>
                                <th className="align-middle text-center">{t('purchase.supplier')}</th>
                                <th className="align-middle text-center">{t('facture.dateFacture')}</th>
                                <th className="align-middle text-center">{t('common.user')}</th>
                                <th className="align-middle text-center">N° Fact Fourn.</th>
                                <th className="align-middle text-center">{t('facture.table.totalTtc')}</th>
                                <th className="align-middle text-center">{t('facture.table.totalHt')}</th>
                                <th className="align-middle text-center">{t('reception.totalTva')}</th>
                                <th className="align-middle text-center">{t('facture.montantRegle')}</th>
                                <th className="align-middle text-center">{t('facture.table.receiptNumbers')}</th>
                                <th className="align-middle text-center">{t('facture.table.status')}</th>
                                <th className="align-middle text-center">{t('facture.table.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices?.length === 0 && (
                                <tr>
                                    <td colSpan="12" className="text-center text-muted">
                                        {t('facture.noInvoices')}
                                    </td>
                                </tr>
                            )}
                            {invoices?.map((invoice) => (
                                <tr key={invoice.id}>
                                    <td className="align-middle text-center">{invoice.numero}</td>
                                    <td className="align-middle text-center">{invoice?.fournisseurNom}</td>
                                    <td className="align-middle text-center">{invoice.dateFacture}</td>
                                    <td className="align-middle text-center">{invoice.createdBy}</td>
                                    <td className="align-middle text-center">{invoice.numeroFactfournisseur || 'N/A'}</td>
                                    <td className="align-middle text-center">{formatPrice(invoice.montantTTC, false)}</td>
                                    <td className="align-middle text-center">{formatPrice(invoice.montantHT, false)}</td>
                                    <td className="align-middle text-center">{formatPrice(invoice.montantTVA, false)}</td>
                                    <td className="align-middle text-center">{formatPrice(invoice.montantRegle, false)}</td>
                                    <td className="align-middle text-center">
                                        {invoice.referenceBons ? (
                                            <div className="d-flex flex-column align-items-center">
                                                {invoice.referenceBons.split(',').map((receipt, index) => (
                                                    <Badge key={index} color="success" className='mb-1' style={{ fontSize: '10px' }}>
                                                        {receipt.trim()}
                                                    </Badge>
                                                ))}
                                            </div>
                                        ) : (
                                            <span className="text-muted">Aucun</span>
                                        )}
                                    </td>
                                    <td className="align-middle text-center">
                                        {getStatusBadge(invoice.statut)}
                                    </td>
                                    <td className="align-middle text-center">
                                        <Button color="secondary" title='Téléchargé PDF' onClick={() => generateSupplierInvoicePdf(invoice, {
                                            company,
                                            openInNewTab: true,
                                        })} size="sm" className="me-1 px-2 py-1">
                                            <FaFilePdf size={12} className="mr-2" />
                                        </Button>
                                        <Button
                                            color="warning"
                                            title={t('facture.edit')}
                                            onClick={() => handleEditInvoice(invoice)}
                                            size="sm"
                                            className="me-1"
                                        //disabled={!canEditInvoice(invoice)}
                                        >
                                            <FaEdit size={12} />
                                        </Button>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="bg-light fw-bold">
                                <td colSpan="5" className="text-end">{t('common.totals')}</td>
                                <td className="align-middle text-center">{formatPrice(invoices.reduce((acc, invoice) => acc + invoice.montantTTC, 0), false)}</td>
                                <td className="align-middle text-center">{formatPrice(invoices.reduce((acc, invoice) => acc + invoice.montantHT, 0), false)}</td>
                                <td className="align-middle text-center">{formatPrice(invoices.reduce((acc, invoice) => acc + invoice.montantTVA, 0), false)}</td>
                                <td className="align-middle text-center">{formatPrice(invoices.reduce((acc, invoice) => acc + invoice.montantRegle, 0), false)}</td>
                                <td colSpan="3"></td>
                            </tr>
                        </tfoot>
                    </table>
                </>)}
            <Modal
                isOpen={showEditModal}
                toggle={handleCloseEditModal}
                size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseEditModal}>
                    {t('facture.editInvoice')} - {selectedInvoiceForEdit?.numero}
                </ModalHeader>
                <ModalBody>
                    {selectedInvoiceForEdit && (
                        <ViewFacture
                            invoice={selectedInvoiceForEdit}
                            onSave={handleCloseEditModal}
                            onCancel={handleCloseEditModal}
                            isEditing={true}
                        />
                    )}
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default SupplierInvoiceList;